import { CollectionOptionType } from './use-collection-list-options';
import { useReducer } from 'react';

export interface EditCollectionsState {
  collections: CollectionOptionType[];
  sortOrderChanged: boolean;
}

export enum EditCollectionsActionType {
  ADD_COLLECTION = 'ADD_COLLECTION',
  REMOVE_COLLECTION = 'REMOVE_COLLECTION',
  RENAME_COLLECTION = 'RENAME_COLLECTION',
  RESET_SORT_ORDER_CHANGED = 'RESET_SORT_ORDER_CHANGED',
  SORT_COLLECTIONS = 'SORT_COLLECTIONS',
}

export type EditCollectionsAction =
  | {
      payload: {
        newCollection: CollectionOptionType;
      };
      type: EditCollectionsActionType.ADD_COLLECTION;
    }
  | {
      payload: {
        collectionUUID: string;
      };
      type: EditCollectionsActionType.REMOVE_COLLECTION;
    }
  | {
      payload: {
        collectionUUID: string;
        name: string;
      };
      type: EditCollectionsActionType.RENAME_COLLECTION;
    }
  | {
      payload: {
        collections: CollectionOptionType[];
      };
      type: EditCollectionsActionType.SORT_COLLECTIONS;
    }
  | {
      type: EditCollectionsActionType.RESET_SORT_ORDER_CHANGED;
    };

const defaultState: EditCollectionsState = {
  collections: [],
  sortOrderChanged: false,
};

export const editCollectionsReducer = (
  state: EditCollectionsState,
  action: EditCollectionsAction,
): EditCollectionsState => {
  switch (action.type) {
    case EditCollectionsActionType.ADD_COLLECTION:
      return {
        ...state,
        collections: [...state.collections, action.payload.newCollection],
      };
    case EditCollectionsActionType.REMOVE_COLLECTION:
      return {
        ...state,
        collections: state.collections.filter(
          (collection) => collection.value !== action.payload.collectionUUID,
        ),
      };
    case EditCollectionsActionType.RENAME_COLLECTION:
      return {
        ...state,
        collections: state.collections.map((collection) => {
          if (collection.value === action.payload.collectionUUID) {
            return {
              ...collection,
              title: action.payload.name,
            };
          }
          return collection;
        }),
      };
    case EditCollectionsActionType.SORT_COLLECTIONS:
      return {
        ...state,
        collections: action.payload.collections,
        sortOrderChanged: true,
      };
    case EditCollectionsActionType.RESET_SORT_ORDER_CHANGED:
      return {
        ...state,
        sortOrderChanged: false,
      };
    default:
      return state;
  }
};

export const useEditCollectionsReducer = (
  initialCollections: CollectionOptionType[],
) => {
  return useReducer(editCollectionsReducer, {
    ...defaultState,
    collections: initialCollections,
  });
};
